var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"shareTipContainer",on:{"click":_vm.hideTip}},[_c('img',{style:({
      width: _vm.remChange(_vm.width),
      top: _vm.remChange(_vm.top),
      right: _vm.remChange(_vm.right)
    }),attrs:{"src":_vm.imgUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }